"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseConfig_1 = require("../BaseConfig");
const Environment_1 = require("../../models/Environment");
const developmentConfig = {
    env: Environment_1.BuildEnvironment.Dev,
    ecs: Object.assign(Object.assign({}, BaseConfig_1.default.ecs), { host: "" }),
    // Same-origin path mocked by webpack.devServer.config.js — see ssoAuthority
    // on IConfig. Unlike the ECS host above, this can't just be "" (relative):
    // CoreServicesAuthSsoDetector builds the authorize URL with `new URL(...)`,
    // which throws on a relative string with no base, so we spell out the
    // origin explicitly.
    ssoAuthority: `${window.location.origin}/mocked-sso-authority`,
    urls: Object.assign(Object.assign({}, BaseConfig_1.default.urls), { absoluteUrls: Object.assign(Object.assign({}, BaseConfig_1.default.urls.absoluteUrls), { brandingService: "/api/mt/beta/meetings/branding", brandingWithMeetingidService: "/api/mt/beta/meetings/brandinginfo" }) }),
};
exports.default = developmentConfig;
